import { DisplayRule, FieldElement, MobileListItem, RowElement, TemplateElement } from '@mobileTypes'

type DisplayRuleSource = {
  id?: number | null
  code?: string
  internalId?: string | null
  title?: string
  objectCode?: string | number | null
  objectTitle?: string
  objectField?: string
  isJS?: boolean
  isJs?: boolean
}

export const buildElementDisplayRuleStub = (
  displayRule: DisplayRuleSource | null | undefined
): DisplayRule | null => {
  if (!displayRule) return null

  return {
    id: 0,
    code: displayRule.code ?? '',
    internalId: displayRule.internalId ?? '',
    title: displayRule.title ?? '',
    objectCode: String(displayRule.objectCode ?? ''),
    objectTitle: displayRule.objectTitle ?? '',
    objectField: displayRule.objectField ?? undefined,
    isJS: displayRule.isJS === true || displayRule.isJs === true,
    displayRuleValues: null,
  }
}

const normalizeRowElementDisplayRule = (element: RowElement): RowElement => ({
  ...element,
  displayRule:
    element.useDisplayRule && element.displayRule
      ? buildElementDisplayRuleStub(element.displayRule)
      : null,
})

const normalizeTemplateElement = (element: TemplateElement): TemplateElement => {
  if (element.type === 'view' || element.type === 'icon') {
    return {
      ...element,
      displayRule: element.displayRule
        ? buildElementDisplayRuleStub(element.displayRule) ?? undefined
        : undefined,
    }
  }

  const field = element as FieldElement
  return {
    ...field,
    displayRule:
      field.useDisplayRule && field.displayRule
        ? buildElementDisplayRuleStub(field.displayRule)
        : null,
  }
}

const normalizeTemplateTree = (elements: TemplateElement[]): TemplateElement[] =>
  elements.map(element => {
    const normalized = normalizeTemplateElement(element)
    if (normalized.type === 'view' && normalized.children?.length) {
      return {
        ...normalized,
        children: normalizeTemplateTree(normalized.children),
      }
    }
    return normalized
  })

export const normalizeListItemDisplayRules = (item: MobileListItem): MobileListItem => {
  const result: MobileListItem = { ...item }

  if (result.icon?.displayRule) {
    result.icon = {
      ...result.icon,
      displayRule: buildElementDisplayRuleStub(result.icon.displayRule) ?? undefined,
    }
  }

  if (result.rows) {
    result.rows = result.rows.map(row => ({
      ...row,
      elements: row.elements.map(normalizeRowElementDisplayRule),
    }))
  }

  if (result.itemTemplate?.children?.length) {
    result.itemTemplate = {
      ...result.itemTemplate,
      children: normalizeTemplateTree(result.itemTemplate.children),
    }
  }

  return result
}
